import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import ComponentRegistration from '@/utils/component-registration';
import VueCookies from 'vue-cookies';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import VueGtag from 'vue-gtag';
import { VTooltip, VPopover, VClosePopover } from 'v-tooltip';
import VueTippy from 'vue-tippy';
import Donut from 'vue-css-donut-chart';
import 'vue-css-donut-chart/dist/vcdonut.css';
import Snotify from 'vue-snotify';
import Vuelidate from 'vuelidate';
import Croppa from 'vue-croppa';
import money from 'v-money';
import * as VueGoogleMaps from 'vue2-google-maps';
import GmapCluster from 'vue2-google-maps/dist/components/cluster'; // replace src with dist if you have Babel issues
import VueCountdown from '@chenfengyuan/vue-countdown';
import VueMeta from 'vue-meta';
import OneSignalVue from 'onesignal-vue';
import VueLazyLoad from 'vue-lazyload';
// sweetalert2
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import VueSmoothScroll from 'vue2-smooth-scroll'

Vue.use(VueSmoothScroll)

const optionsSweetalert = {
    customClass: {
        confirmButton: 'eg-button-sweetalert eg-button-blue',
        cancelButton: 'eg-button-sweetalert eg-blue-outline'
    },
    reverseButtons: true,
    buttonsStyling: false
};
// import VueSmoothScroll from 'vue2-smooth-scroll'

// // scroll suave
// Vue.use(VueSmoothScroll)

// usando sweetalert
Vue.use(VueSweetalert2, optionsSweetalert);

// usando o oneSignal
Vue.use(OneSignalVue);

// register directive v-money and component <money>
Vue.use(money, { precision: 4 });

import infiniteScroll from 'vue-infinite-scroll';
Vue.use(infiniteScroll);

// snack bar de ação e mensagem de alerta
const snotifyConfig = {
    toast: {
        timeout: 5000,
        position: 'centerBottom',
        showProgressBar: false,
        bodyMaxLength: 3000
    }
};
Vue.use(Snotify, snotifyConfig);
// Registro do vuelidate
Vue.use(Vuelidate);
// Registro de componente de imagem
Vue.use(Croppa);
// Registro do vue countdown
Vue.component(VueCountdown.name, VueCountdown);
// regitro do vue metag
Vue.use(VueMeta);

// Registro de Icones
library.add(fas);
Vue.component('font-awesome-icon', FontAwesomeIcon);

// Registro de Cookies
Vue.use(VueCookies);
Vue.$cookies.config('12h');

// Registro do ToolTip
Vue.directive('tooltip', VTooltip);
Vue.directive('close-popover', VClosePopover);
Vue.component('v-popover', VPopover);
Vue.use(VTooltip);

// Registro do tippy
Vue.use(VueTippy);

// Registro do Donut/PizzaChart
Vue.use(Donut);
// GTAG
Vue.use(
    VueGtag,
    {
        config: {
            id: process.env.VUE_APP_ANALYTICS_ID,
            params: {
                optimize_id: process.env.VUE_APP_OPTIMIZE_ID
            }
        },
        includes: [{ id: process.env.VUE_APP_TAG_MANAGER_ID }]
    },
    router
);
// Vue google maps
Vue.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyCC3ycn1VMizbJhn_SCDNzQYB6GYHjtD70',
        region: 'BR',
        language: 'pt-BR'
    }
});

// lazyload para imagens lighbox
Vue.use(VueLazyLoad);

Vue.component('gmap-marker', VueGoogleMaps.Marker);
Vue.component('gmap-cluster', GmapCluster);

// fount-awesome
import '@fortawesome/fontawesome-free/css/all.css';
import '@fortawesome/fontawesome-free/js/all.js';

// Assetes
import '@/assets/css/styles.css';
import '@/assets/css/materialize.min.css';
import 'vue-select/dist/vue-select.css';
import 'animate.css';
// Registros de Componentes
ComponentRegistration();
Vue.config.productionTip = false;
new Vue({
    router,
    store,
    render: h => h(App),
    beforeMount() {
        if (process.env.VUE_APP_ENV != 'local') this.$OneSignal.init({ appId: process.env.VUE_APP_ONESIGNAL_KEY });
    }
}).$mount('#app');
